export const PDF_EEG_EVALUATION_FONT_SIZE = {
    body: 10,
    title: 17,
    subtitle: 14,
    sectionSubtitle: 12,
};
